<template>
  <!--add signature modal-->
  <b-modal v-model="showModal" :width="800" scroll="keep" animation="zoom-out" :can-cancel="false">
    <div class="model-card">

      <header class="modal-card-head">
        <p class="modal-card-title">Add Signature</p>
        <button @click="closeModal" type="button" class="delete"></button>
      </header>

      <div class="modal-card-body">
        <div class="content pt-2">
          <div class="columns is-gapless">
            <div class="column is-2">
              <div class="item"
                   :class="{ 'item-selected' : addSignatureModalSideBarSelection.sign }"
                   @click="setAddSignatureModalSidebarActiveSelection('sign')">
                <img src="../../../assets/icon/type.png" alt="type-icon">
                <p style="color: #0D5DA3">Sign</p>
              </div>
              <div class="item"
                   :class="{ 'item-selected' : addSignatureModalSideBarSelection.draw }"
                   @click="setAddSignatureModalSidebarActiveSelection('draw')">
                <img src="../../../assets/icon/draw.png" alt="draw-icon">
                <p style="color: #0D5DA3">Draw</p>
              </div>
              <div class="item"
                   :class="{ 'item-selected' : addSignatureModalSideBarSelection.upload }"
                   @click="setAddSignatureModalSidebarActiveSelection('upload')">
                <img src="../../../assets/icon/upload.png" alt="upload-icon">
                <p style="color: #0D5DA3">Upload</p>
              </div>

            </div>
            <div class="column">
              <div class="area">

                <!-- body content -->

                <!-- sign type content -->
                <template v-if="addSignatureModalSideBarSelection.sign">
                  <b-field>
                    <b-input type="text"
                             v-model="userInputSignatureText"
                             placeholder="Cameron Williamson"
                             value=""
                             rounded>
                    </b-input>
                  </b-field>

                  <!--Typed Verified signatures display area-->
                  <template v-if="verifiedSignatures.signTyped.length > 0" >
                    <p>Verified Signatures</p>

                    <!--  This special looping is used to display 3 signatures in one row  -->
                    <div class="columns"  v-for="i in Math.ceil(verifiedSignatures.signTyped.length / 3)" style="padding: 8px" :key="getRandomInt(100000)+i">
                      <div class="signatureDisplayArea" v-for="verifiedSignature in verifiedSignatures.signTyped.slice((i - 1) * 3, i * 3)" :key="verifiedSignature.signature_path">
                        <VerifiedSignature @on-verified-signature-selected="getVerifiedSignature" :signature="verifiedSignature"></VerifiedSignature>
                      </div>
                    </div>
                  </template>

                  <!-- Digitally generated signatures display area-->
                  <template v-if="userInputSignatureText !== '' ">
                    <p>Newly Generated Signatures</p>

                    <div class="columns">

                      <div class="column"><TypedSignature :typed-signature="userInputSignatureText" :fontFamilyId="0"  @on-html-to-canvas="getTypedSignature"/></div>
                      <div class="column"><TypedSignature :typed-signature="userInputSignatureText" :fontFamilyId="4"  @on-html-to-canvas="getTypedSignature"/></div>
                      <div class="column"><TypedSignature :typed-signature="userInputSignatureText" :fontFamilyId="2"  @on-html-to-canvas="getTypedSignature"/></div>
                    </div>
                  </template>

                </template>


                <!-- draw content -->
                <template v-else-if="addSignatureModalSideBarSelection.draw">

                  <DrawSignature @on-add-signature="getDrawnSignature"/>

                </template>

                <!-- upload content -->
                <template v-else-if="addSignatureModalSideBarSelection.upload">

                  <div class="uploadSignatureArea">
                    <p>Click image to capture/upload signature</p>
                    <UploadSignature  @on-captured="getUploadedSignature" :crop_ratio=12/4 file_name="customer_uploaded_signature" style="width: 50%; margin: auto;" />

                  </div>
                </template>


              </div>
            </div>
          </div>

          <!-- Modal button action area-->
          <div class="columns is-gapless">

            <div class="column is-2">
            </div>
            <div class="column" >
              <div class="signatureModalButtonArea">
                <div style="margin-right: auto;">
                  <b-field>
                    <b-checkbox
                        size="is-small"
                        :disabled="disableModalButtons"
                        v-model="isDefaultSignature"
                    >
                      Save this signature as default
                    </b-checkbox>
                  </b-field>
                </div>

                <div>
                  <b-button rounded outlined class="is-info" @click="addSignature()" :loading="addSignatureBtnIsLoading" :disabled="disableModalButtons">Add Signature</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <EnterOTPModal v-if="showEnterOtpModal" @on-otp-valid="afterOtpVerified"></EnterOTPModal>
  </b-modal>
</template>


<script>

import TypedSignature from '@/components/frontend/AddSignatureModal/TypedSignature'
import DrawSignature from '@/components/frontend/AddSignatureModal/DrawSignature'
import UploadSignature from '@/components/frontend/AddSignatureModal/UploadSignature'
import VerifiedSignature from "@/components/frontend/AddSignatureModal/VerifiedSignature";
import EnterOTPModal from "@/components/frontend/EnterOTPModal";
import axios from "axios";
import Signature from "@/classes/Signature";

export default {
  name: 'add-signature',

  components:{
    TypedSignature,
    DrawSignature,
    UploadSignature,
    VerifiedSignature,
    EnterOTPModal,

  },

  data(){
    return {
      showModal: true,

      isDefaultSignature : false, // use to store if the signature is default

      addSignatureModalSideBarSelection:{ // use to control sidebar selection of the modal and to display relevant content
        sign:true,
        draw:false,
        upload:false,
      },

      showEnterOtpModal : false, // variable to show/hide enter otp modal

      selectedSignature : null, // variable to store the selected signature, (Signature class type objects)
      disableModalButtons: true, // initially disable modal buttons
      addSignatureBtnIsLoading: false,

      isVerifiedSignaturesAvailable:false, // set true to test

      verifiedSignatures : {// variable to store the verified signatures
        signTyped:[],
        signDraw:[],
        signUpload:[],
      },

      userInputSignatureText:'',// variable to store signature that user entered


    }
  },

  watch:{

    // this watcher method is used to enable buttons and checkboxes if user select a signature
    selectedSignature(){
      if(this.selectedSignature != null){
        this.disableModalButtons = false
      }
      else{
        this.disableModalButtons = true
      }

    }
  },

  methods:{

    /**
     * This  method is used to emit close event without selecting a signature
     */
    closeModal(){
      console.log("Close AddSignatureModal --------------------")
      this.$emit('closeModal')
    },

    /**
     * This method is used to emit the close event after adding a signature
     * @param signature
     */
    closeModalAfterSignatureAdded(signature){
      console.log("Close signature modal after signature was added ----------")
      console.log("Added Signature : "+signature)

      let returnData = {signature : signature}
      this.$emit('on-signature-added',returnData)
    },

    /**
     * this method is used to execute command after otp is verified
     * @param e
     */
    afterOtpVerified(e){
      const comp = this

      if(e.isOtpVerified){

        console.log("Otp verified date time : "+e.otpVerifiedTime)
        console.log("Is default Signature : "+comp.isDefaultSignature)

        comp.showEnterOtpModal= false
        comp.addSignatureBtnIsLoading = true

        comp.saveSignature(comp.selectedSignature,e.otpVerifiedTime,comp.$root.customerData.nicNumber,comp.isDefaultSignature)
      }
    },

    /**
     * This method can be used to save a signature
     * @param signature
     * @param otpVerifiedTime
     * @param inviteeNic
     * @param isDefault
     */
    saveSignature(signature,otpVerifiedTime,inviteeNic,isDefault){
      const comp = this
      console.log("Signature before adding verified signature : "+signature.verifiedSignatureData)

      var signatureData = new FormData();

      signatureData.append("invitee_nic",inviteeNic);
      signatureData.append("signature_type", signature.type);
      signatureData.append("is_default", isDefault);
      signatureData.append("otp_verified_time", otpVerifiedTime);
      signatureData.append("signature_image", signature.imageFile);
      signatureData.append("invitee_token", comp.$root.invitee_token);

      try {
        axios.post(
            comp.$base_url+'/customer/saveInviteeSignature',
            signatureData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            },
        )
            .then(function (response) {

              console.log("Saved signature data")
              console.log(response)

              if(response.data.success){
                console.log("success")

                signature.isSignatureVerified = true
                signature.verifiedSignatureData = response.data.data.signature

                console.log("Signature after adding verified signature : "+signature.verifiedSignatureData)
                comp.closeModalAfterSignatureAdded(signature)

              }
              else{
                comp.$buefy.toast.open({
                  message: "Failed to save the signature",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)
              comp.$buefy.toast.open({
                message: "Failed to save the signature",
                type: "is-danger",
              });
            });

      }
      catch (e){
        comp.$buefy.toast.open({
          message: "Failed to save the signature",
          type: "is-danger",
        });
        console.log("Exception occurred in AddSignatureModal saveSignature() : "+e.message)
      }
    },


    setAddSignatureModalSidebarActiveSelection:function (sidebarItem){
      console.log("Current add signature modal sidebar selection : "+sidebarItem)

      if(sidebarItem === 'sign'){
        this.addSignatureModalSideBarSelection.sign = true
        this.addSignatureModalSideBarSelection.draw = false
        this.addSignatureModalSideBarSelection.upload = false
      }
      else if(sidebarItem === 'draw'){
        this.addSignatureModalSideBarSelection.sign = false
        this.addSignatureModalSideBarSelection.draw = true
        this.addSignatureModalSideBarSelection.upload = false
      }
      else{
        this.addSignatureModalSideBarSelection.sign = false
        this.addSignatureModalSideBarSelection.draw = false
        this.addSignatureModalSideBarSelection.upload = true
      }

      this.selectedSignature = null
    },

    /**
     *  This method is used to add an already verified or new signature
     */
    addSignature:function (){
      const comp = this

      // test console data -----------------------------------
      if(comp.addSignatureModalSideBarSelection.sign){
        var sidebarType = 'text'
      }
      else if(comp.addSignatureModalSideBarSelection.draw){
        sidebarType = 'canvas'
      }
      else if(comp.addSignatureModalSideBarSelection.upload){
        sidebarType = 'upload'
      }
      console.log("Selected sidebar signature type : "+sidebarType)
      console.log("Selected signature type : "+comp.selectedSignature.type)

      // end of test console data ----------------------------

      if(comp.selectedSignature == null){
        console.log("No Signature found")
      }
      else {

        console.log("Selected signature is verified : "+comp.selectedSignature.isSignatureVerified)

        if(comp.selectedSignature.isSignatureVerified){
          console.log("Already verified signature")
          comp.closeModalAfterSignatureAdded(comp.selectedSignature)
        }
        else{
          console.log("New signature save procedure")
          comp.showEnterOtpModal = true
        }
      }
    },

    getTypedSignature(e){
      const comp = this
      console.log("Received typed (generated) image url : "+e.imageUrl)
      console.log("Received typed (generated) image file : "+e.imageFile)

      comp.selectedSignature = e // received signature object through the event

    },

    getDrawnSignature(e){
      console.log("Received drawn image url : "+e.imageUrl)
      console.log("Received drawn image file : "+e.imageFile)

      this.selectedSignature = e
    },

    getUploadedSignature(e){
      console.log("Received Upload signature url : "+e.imageUrl)
      console.log("Received Upload signature file : "+e.imageFile)

      this.selectedSignature = e
    },

    getVerifiedSignature(e){
      console.log("Received Verified Signature url : "+e.imageUrl)
      console.log("Received Verified Signature file : "+e.imageFile)

      this.selectedSignature = e

    },

    getSavedSignatures(){
      const comp = this
      var allSavedSignatures = []
      try {
        axios.post(
            comp.$base_url+'/customer/getInviteeSignatures',
            {
              invitee_nic :  comp.$root.customerData.nicNumber,
              invitee_token : comp.$root.invitee_token
            },
        )
            .then(function (response) {

              console.log("Saved signature data")
              console.log(response)

              if(response.data.success){
                console.log("success")

                allSavedSignatures = response.data.data.inviteeSignatureList

                console.log("All signatures : "+ allSavedSignatures)
                allSavedSignatures.forEach(function (signature){
                  console.log(signature.signature_type)

                  if(signature.signature_type === 'text'){

                    let isVerifiedSignature = signature.otp_verified == 1 ? true : false
                    let publicImageURL = comp.$base_public_url+signature.signature_path

                    let savedTextTypeSignature = new Signature(signature.signature_type,publicImageURL,null,isVerifiedSignature,signature)

                    comp.verifiedSignatures.signTyped.push(savedTextTypeSignature)
                  }
                })

              }
              else{
                comp.$buefy.toast.open({
                  message: response.data.data.message,
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)
              comp.$buefy.toast.open({
                message: "Failed to get saved signatures",
                type: "is-danger",
              });
            });

      }
      catch (e){
        comp.$buefy.toast.open({
          message: "Failed to get saved signatures",
          type: "is-danger",
        });
        console.log("Exception occurred in AddSignatureModal getSavedSignatures() : "+e.message)
      }
    },

    /**
     * This method is used to generate random integer number
     * @param max maximum output integer
     * @returns {number} random integer number
     */
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
  },

  mounted() {
    this.getSavedSignatures()
  }

}
</script>

<style scoped>

/* Signature modal styles */
.item img{
  width: 60px;

}


.item{
  padding: 10px 10px 10px 30px;
  border-top-left-radius: 100%;
  border-bottom-left-radius: 100%;
}

.item:hover{
  background-color: #F2F4FF;
}

.item-selected{
  background-color: #F2F4FF;
}

.area{
  height: 100%;
  width: 100%;
  background-color: #F2F4FF;
  padding: 10px;
}

.buttons{
  margin-top: 80%;
  display: block;
}

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 36px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
}

.signatureModalButtonArea{
  display: flex;
}

.uploadSignatureArea{
  margin-top: 5%;
}

.signatureDisplayArea{
  width: 190px;
  margin: 8px
}


</style>
